export const common = {
  create: {
    success: 'Create successfully',
    fail: 'Create fail',
  },
  update: {
    success: 'Update successfully',
    fail: 'Update fail',
  },
  delete: {
    success: 'Delete successfully',
    fail: 'Delete fail',
  },
  import: {
    success: 'Import successfully',
    fail: 'Import fail',
  },
}
